module.exports = __webpack_public_path__ + "img/12.c4736c92.jpg";